import APIController from "./APIController"
const SyncController = () =>{
    //Requesthelper
    const {basicRequest, jsonRequest, getWorkspaceId} = APIController()

    const fetchSyncTimestamp = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/get_timestamp`);
        return data;
    };

    const fetchCategories = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/get_categories`);
        return data;
    };

    const fetchExtras = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/get_extras`);
        return data;
    };

    const fetchOffers = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/get_offers`);
        return data;
    };

    const fetchDiscounts = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/get_discounts`);
        return data;
    };

    const fetchProducts = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/get_products`);
        return data;
    };

    const fetchWorkspace = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/get_workspace`);
        return data;
    };

    const fetchOrders = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/get_orders`);
        return data;
    };

    const fetchTimeTracking = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/get_time_tracking`);
        return data;
    };

    const fetchRegisterEntries = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/get_cash_register_entries`);
        return data;
    };

    const fetchWorkspaceUser = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/sync/get_workspace_user`);
        return data;
    };

    const uploadDTO = async (orderDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/sync/upload_orders`, "POST", orderDTO);
        return data;
    };

    const uploadProductStock = async (dto) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/sync/upload_product_stock`, "POST", dto);
        return data;
    };

    const uploadRegisterEntries = async (dto) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/sync/upload_cash_register_entries`, "POST", dto);
        return data;
    };

    const uploadOffer = async (offerDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/sync/upload_offers`, "POST", offerDTO);
        return data;
    };

    const uploadTimeTracking = async (dto) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/sync/upload_time_tracking`, "POST", dto);
        return data;
    };

    const ping = async () => {
        const data = await basicRequest(`/health`);
        return data;
    }

    return {
        ping,
        fetchSyncTimestamp,
        uploadDTO,
        uploadProductStock,
        uploadOffer,
        uploadRegisterEntries,
        fetchCategories,
        fetchDiscounts,
        fetchExtras,
        fetchOffers,
        fetchProducts,
        fetchOrders,
        fetchRegisterEntries,
        fetchWorkspaceUser,
        fetchWorkspace,
        fetchTimeTracking,
        uploadTimeTracking
    }
}

export default SyncController